import { styled } from '@mui/material/styles';
import { IconButton } from '../../IconButton';

export const IconButtonStyled = styled(IconButton)`
  align-self: flex-end;
  padding: 2px;
`;
